interface GenericMessageFormat {
  msgFormatting: string
  msgText: string
}
export const RoleNotAssignedMsg: GenericMessageFormat = {
  msgFormatting: 'text-red-600 text-bold flex items-center font-normal md:font-bold',
  msgText: 'ERROR: You are not asigned any roles in Tradewinds application. Please contact Technology.'
}
